import { inject, Injectable } from '@angular/core';
import { Store } from '@sama/app-state';
import { keys } from '@sama/micro-dash';
import { FusionState } from '../../../../../../../core/h3ml/state/fusion-state';
import { FusionManager } from '../../../../../../../core/outputs/annotation/annotation-shared/fusion/fusion-manager';
import { EventTrackingService } from '../../../../../../../shared/event-tracking/event-tracking.service';
import { outputAnnotationInfoStoreToken } from '../../../../annotation-providers';

@Injectable()
export class ShapeListPanelService {
  private readonly outputAnnotationInfoStoreToken = inject(
    outputAnnotationInfoStoreToken,
  );
  private readonly shapesStore = this.outputAnnotationInfoStoreToken('shapes');
  private fusionStore: Store<FusionState>;

  constructor(
    private eventTrackingService: EventTrackingService,
    fusionManager: FusionManager,
  ) {
    this.fusionStore = fusionManager.fusionStore;
  }

  setExpandedStateForAllShapeListPanels(expanded: boolean) {
    const shapeIndices = keys(this.shapesStore.state());
    const groups = keys(this.outputAnnotationInfoStoreToken.state().groups);
    groups.forEach((i) => {
      this.setGroupPanelState(+i, expanded);
    });
    shapeIndices.forEach((i) => {
      this.setShapePanelState(+i, expanded);
    });
    this.eventTrackingService.track({
      id: 'expand_shape_list',
      bucket: 'tag_selection',
      expanded,
    });
  }

  isShapePanelExpanded$(index: number) {
    return this.fusionStore('shapeListPanelExpanded')('shapes')(
      index.toString(),
    ).$;
  }

  isGroupPanelExpanded$(index: number) {
    return this.fusionStore('shapeListPanelExpanded')('groups')(
      index.toString(),
    ).$;
  }

  toggleGroupPanelExpanded(index: number) {
    const currentExpansionState =
      this.fusionStore.state().shapeListPanelExpanded.groups[index];
    this.setGroupPanelState(index, !currentExpansionState);
  }

  setGroupPanelState(index: number, isPanelExpanded: boolean) {
    this.fusionStore('shapeListPanelExpanded')('groups')(index.toString()).set(
      isPanelExpanded,
    );
  }

  setShapePanelState(index: number, isPanelExpanded: boolean) {
    this.fusionStore('shapeListPanelExpanded')('shapes')(index.toString()).set(
      isPanelExpanded,
    );
  }
}
